import React, { useState, useEffect, useRef } from "react";
import Select from "../common/Select";
import {
  getAllTeamClients,
  getClientCarePlans,
  getTeamClients,
} from "../services/soar";
import { getFieldDate, getFieldName } from "../../scripts/helperScripts";
import ReportsExpand from "../common/ReportsExpand";

function CarePlanReport({
  divisions,
  month,
  year,
  isFavorite,
  toggleFavorite,
  ...rest
}) {
  const [reportData, setReportData] = useState({
    Division: "",
    Client: "",
    CarePlan: "",
  });
  const [clientOptions, setClientOptions] = useState([]);
  const [carePlanOptions, setCarePlanOptions] = useState([]);
  const [carePlansFetched, setCarePlansFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showDischarged, setShowDischarged] = useState(false);
  const isMountedRef = useRef(true);
  const reportOrg =
    process.env.REACT_APP_ENVIRONMENT === "Production"
      ? "SOARLive"
      : "SOARD365Base";

  useEffect(() => {
    return () => (isMountedRef.current = false);
  }, []);

  useEffect(() => {
    if (reportData.Division !== "") {
      setLoading(true);
      if (showDischarged)
        getAllTeamClients([reportData.Division]).then((response) => {
          if (isMountedRef.current) {
            if (response) {
              const options = response.map((contact) => ({
                _id: contact.contactid,
                name: contact.fullname,
              }));
              setClientOptions(options);
            }

            setLoading(false);
          }
        });
      else
        getTeamClients([reportData.Division]).then((response) => {
          if (isMountedRef.current) {
            if (response) {
              const options = response.map((contact) => ({
                _id: contact.contactid,
                name: contact.fullname,
              }));
              setClientOptions(options);
            }

            setLoading(false);
          }
        });
    }
  }, [reportData.Division, showDischarged]);

  //Get Care Plans
  const loadCarePlans = async (clientId) => {
    if (clientId === "") {
      return;
    }

    setCarePlanOptions([]);
    setCarePlansFetched(false);

    const response = await getClientCarePlans(clientId);
    if (!isMountedRef.current) {
      return;
    }

    if (!response || response.length === 0) {
      setCarePlansFetched(true);
      return;
    }

    console.log(response);
    const options = response.map((carePlan) => {
      const carePlanStatus = getFieldName(carePlan.ccx_careplan_status);

      return carePlanStatus === "Draft in Progress"
        ? {
            _id: carePlan.ccx_careplanid,
            name: carePlanStatus,
          }
        : {
            _id: carePlan.ccx_careplanid,
            name: `${carePlanStatus} - ${getFieldName(
              carePlan.ccx_careplan_type
            )} - ${getFieldDate(carePlan.ccx_effectivedate)}`,
          };
    });

    setCarePlanOptions(options);
    setCarePlansFetched(true);
  };

  const handleChange = ({ currentTarget: input }) => {
    console.log("input: ", input, input.value);
    const data = { ...reportData };
    data[input.name] = input.value;
    setReportData(data);
  };

  const handleClientChange = (e) => {
    const data = { ...reportData };
    data[e.currentTarget.name] = e.currentTarget.value;
    data.CarePlan = "";
    setReportData(data);

    loadCarePlans(e.currentTarget.value);
  };

  const openReport = () => {
    console.log("Report Org: ", process.env.REACT_APP_ENVIRONMENT);
    const url = `https://safyreports.azurewebsites.net/Reports/CarePlan/Default?db=${reportOrg}&i=${reportData.CarePlan}`;
    // console.log("Census Division", CensusMonth);
    // const url = `https://safyreports.azurewebsites.net/Reports/Census/Division?db=SOARLive&div=${CensusDivision.current.value}&m=${CensusMonth.current.value}&y=${CensusYear.current.value}`;
    window.open(url, "Care Plan Report");
  };

  return (
    <ReportsExpand
      title="Care Plan Report"
      isFavorite={isFavorite}
      toggleFavorite={toggleFavorite}
      {...rest}
    >
      <div className="row">
        <Select
          className="col col-2"
          name="Division"
          label="Division"
          options={divisions}
          onChange={handleChange}
        />
        <div
          className="col-2 form-check form-switch"
          style={{ marginTop: "38px" }}
        >
          <input
            className="form-check-input"
            type="checkbox"
            id="discharged"
            checked={showDischarged}
            onChange={() => setShowDischarged(!showDischarged)}
          />
          <label className="form-check-label" htmlFor="discharged">
            Show Discharged
          </label>
        </div>
        {!loading ? (
          <>
            <Select
              className="col col-3"
              name="Client"
              label="Client"
              options={clientOptions}
              onChange={handleClientChange}
            />
            {carePlansFetched && carePlanOptions.length > 0 && (
              <Select
                className="col col-3"
                name="CarePlan"
                label="Care Plans"
                options={carePlanOptions}
                onChange={handleChange}
              />
            )}
            {carePlansFetched &&
              carePlanOptions.length === 0 &&
              reportData.Client !== "" && (
                <div className="col col-3">
                  Care Plans
                  <div className="text-white mt-2">
                    No Care Plans for Client
                  </div>
                </div>
              )}
            {!carePlansFetched && <div className="col col-3">Care Plans</div>}
            {reportData.CarePlan && (
              <i
                className="fas fa-arrow-circle-right fa-3x col col-2 float-end"
                onClick={openReport}
              ></i>
            )}
          </>
        ) : (
          <>Loading</>
        )}
      </div>
    </ReportsExpand>
  );
}

export default CarePlanReport;
